export default __webpack_public_path__ + "static/media/LoginBackgroundFasano.da59de63.webp";